<template>
  <el-dialog
    :visible.sync="visible"
    :title="type==1?'修改支付密码':'设置支付密码'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" width="550px">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
		<el-form-item label="手机号" v-if="type==1">
		  <el-input v-model="infodata.mobile" :disabled="true"></el-input>
		</el-form-item>
		<el-form-item prop="code" label="短信验证码" v-if="type==1">
			<el-input class="codeInput" style="width: 247px;margin-right: 15px;" placeholder="请输入验证码" v-model="dataForm.code"></el-input>
			<el-button type="info" style="width: 100px;height: 34px;line-height: 34px;border-radius: 14px;padding: 0;" @click="sendCode" v-show="isShow">发送验证码</el-button>
			<el-button type="info" :disabled="false" v-show="!isShow" style="padding: 0;width: 100px;height: 34px;line-height: 34px;border-radius: 14px;background-color: lightgrey">{{secondsCount}}秒</el-button>
		</el-form-item>
      <el-form-item prop="password" label="支付密码">
        <el-input v-model="dataForm.password" type="password" autocomplete="new-password" placeholder="支付密码"></el-input>
      </el-form-item>
      <!-- <el-form-item v-if="type==1" label="验证码：" prop="verificationCode" v-show="true">
          <el-col :span="14">
              <el-input v-model="dataForm.verificationCode" :placeholder="$t('login.captcha')">
                  <span slot="prefix" class="el-input__icon">
                      <svg class="icon-svg" aria-hidden="true">
                          <use xlink:href="#icon-safetycertificate"></use>
                      </svg>
                  </span>
              </el-input>
          </el-col>
          <el-col :span="8" class="login-captcha">
              <img :src="captchaPath" @click="getCaptcha()" style="width:100%;height:100%;margin-top:-15px;">
          </el-col>
      </el-form-item> -->
      <el-form-item prop="confirmPassword" label="确认支付密码">
        <el-input v-model="dataForm.confirmPassword" type="password" autocomplete="new-password" :placeholder="$t('updatePassword.confirmPassword')"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { clearLoginInfo } from '@/utils'
import aesJs from '../../../utils/login-aes'
 import {
  getUUID
} from '@/utils'
export default {
  data () {
    return {
      visible: false,
	  type: 0,
	  secondsCount: 0, // 倒计秒数初始化定义
	  isShow: true, // 是否显示发送验证码按钮
	  infodata: [],
      dataForm: {
        code: '',
        password: '',
        confirmPassword: '',
        verificationCode:'',//验证码
      }
    }
  },
  computed: {
    dataRule () {
      var validateConfirmPassword = (rule, value, callback) => {
        if(!/^[A-Za-z0-9]{6}$/.test(value)) {
          return callback(new Error('请输入6位数密码'))
        }
        if (this.dataForm.password !== value) {
          return callback(new Error(this.$t('updatePassword.validate.confirmPassword')))
        }
        callback()
      }
      var checkPassword = (rule, value, callback) => {
        if(!/^[A-Za-z0-9]{6}$/.test(value)) {
          return callback(new Error('请输入6位数密码'))
        }
        callback()
      }
	  if (this.type == 1) {
		  return {
          code: [
			      { required: true, message: '请输入验证码', trigger: 'blur' }
			  ],
		    password: [
		      { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' }
		    ],
		    confirmPassword: [
		      { required: true, message: this.$t('validate.required'), trigger: 'blur' },
		      { validator: validateConfirmPassword, trigger: 'blur' }
		    ],
        verificationCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
        ]
		  }
	  } else {
		 return {
		   password: [
		     { required: true, message: this.$t('validate.required'), trigger: 'blur' }
		   ],
		   confirmPassword: [
		     { required: true, message: this.$t('validate.required'), trigger: 'blur' },
		     { validator: validateConfirmPassword, trigger: 'blur' }
		   ]
		 }
	  }
    }
  },
  methods: {
    init () {
      // this.getCaptcha();
      this.visible = true
	  this.getuserinfo()
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    // 获取验证码
    getCaptcha () {
        this.dataForm.uuid = getUUID()
        this.captchaPath = `${window.SITE_CONFIG['apiURL']}/sys/account/set-pay-pass/send-code?uuid=${this.dataForm.uuid}`
    },
    getuserinfo () {
      this.$http
        .get('/sys/user/info')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.infodata = res.data
          console.log(this.infodata)
        })
        .catch(() => {})
    },
    sendCode () {
	    // 发送短信验证

	    this.$http.post('/sys/account/set-pay-pass/send-code', {}, {
	    	headers: {
	    		'content-type': 'application/json;charset=UTF-8'
	    	}
	    }).then(res => {
	        // 倒计时
	    	if (res.data.code == 0) {
	    		let that = this
	    		console.log(that)
	    		that.secondsCount = 60
	    		// 切换倒计时按钮
	    		that.isShow = false
	    		// 倒计时函数
	    		let timer = setInterval(function () {
	    		    that.secondsCount--
	    		    if (that.secondsCount <= 0) {
	    		        clearInterval(timer)
	    		        that.isShow = true
	    		    }
	    		}, 1000)
	    	} else {
	    		this.$message.error(res.data.msg)
	    	}
	    })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        //校验支付密码

        let url = '/sys/account/set-pay-pass/submit'
        // if(this.type == 1){
        // 	url ="/sys/account/set-pay-pass/submit";
        // }else{
        // 	url ="/sys/account/set-pay-pass";
        // }
        let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
        paramsForm.password = aesJs.encrypt(paramsForm.password)
        paramsForm.confirmPassword = aesJs.encrypt(paramsForm.confirmPassword)
        // if(paramsForm.password == paramsForm.confirmPassword){
        //   return this.$message.error('新密码不能与旧密码一致！')
        // }
        this.$http.post(url, paramsForm).then(({ data: res }) => {
          // this.dataForm.password = aesJs.decrypt(this.dataForm.password)
          // this.dataForm.confirmPassword = aesJs.decrypt(this.dataForm.confirmPassword)
          if (res.code !== 0) {
            this.getCaptcha();
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList',this.type)
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
